export function reCaptchaConfigFactory() {
  return window['__CPC__']()['reCaptchaSiteKey'];
}
